// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shipment-status-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 7%;
  margin-top: 50px;
}

.data .icon {
  margin-right: 10px;
  height: 48px;
  width: 48px;
  display: flex;
  background: #f8f9fa;
  justify-content: center;
  border-radius: 29px;
  align-items: center;
  border: 2px solid #ffffff;
  box-shadow: 0px 4px 4px 0px #373d430d;
}

.summary {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 190px;
  border-radius: 8px;
  border: 1px solid #e1e9ef;
}

.summary-content {
  width: 50%;
  height: 100%;
  padding: 20px;
}

.data {
  display: flex;
}

p.text-gray-700 {
  margin: 0px;
}

.shipment-status-content-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 150px;
  height: 150px;
  top: 340px;
  left: 630px;
  gap: 0px;
  border-radius: 100px 0px 0px 0px;
  opacity: 0px;
}

.icon-container {
  width: 150px;
  height: 150px;
  border-radius: 100px;
  background: hsl(167, 60%, 97%);
  display: flex;
  justify-content: center;
  margin-top: 35px;
  align-items: center;
}

.icon-container.error {
  background-color: #ff00000a !important;
}

.icon-container img {
  width: 60px;
  height: 48px;
}

.divider {
  width: 1px;
  height: 100%;
  background: #e1e9ef;
}

.col-span-2.flex.justify-between.items-center {
  height: 74px;
  width: 100%;
  border: 1px solid #e1e9ef;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;

}

.data.downloand-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
}

.downloand-container a {
  color: #4793ef;
  text-decoration: none;
}

.button-shipment-status {
  margin-right: 20px;
}

.footer-status {
  width: 100%;
  margin-bottom: 100px;
}

.footer-status h3 {
  font-family: Nunito;
  font-size: 30px;
  font-weight: 800;
  line-height: 42px;
  text-align: left;
  margin-bottom: 10px;
}

.footer-status p {
  font-family: Nunito;
  font-size: 16px;
  font-weight: 400;
  color: #777a7c;
  line-height: 22px;
  text-align: left;
}

@media (max-width: 920px) {
  .summary {
    flex-direction: column;
    height: auto;
    align-items: start;
  }
  .divider {
    width: calc(100% - 40px);
    height: 1px;
    background: #e1e9ef;
    margin: 0 20px;
  }
}

@media (max-width: 785px) {
  .col-span-2.flex.justify-between.items-center {
    flex-direction: column;
    height: auto;
    padding: 15px 0;
    align-items: start;
  }
  .button-shipment-status {
    width: calc(100% - 40px);
    margin: 12px 20px;
  }
  .downloand-container a {
    word-break: break-word;
    /* word-wrap: break-word; */
  }
  .data.downloand-container{
    margin: 0 20px;
  }
  .button-container {
    width: 91.4%;
  }

  .animated-button {
    width: 100%;
  }
}



.animated-button {
  animation: showHideShadow 2s infinite;
}

@keyframes showHideShadow {
  0%, 100% {
      box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  50% {
      box-shadow: 0 0 20px #4793ef;
  }
}


.button-container {
  margin-right: 20px;
  margin-left: 20px;
}

.footer-status strong {
  font-family: Nunito;
  font-size: 16px;
  color: #777a7c;
  line-height: 22px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/ShipmentStatus/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,QAAQ;EACR,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;;;AAIA;EACE,qCAAqC;AACvC;;AAEA;EACE;MACI,kCAAkC;EACtC;EACA;MACI,4BAA4B;EAChC;AACF;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".shipment-status-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0 7%;\n  margin-top: 50px;\n}\n\n.data .icon {\n  margin-right: 10px;\n  height: 48px;\n  width: 48px;\n  display: flex;\n  background: #f8f9fa;\n  justify-content: center;\n  border-radius: 29px;\n  align-items: center;\n  border: 2px solid #ffffff;\n  box-shadow: 0px 4px 4px 0px #373d430d;\n}\n\n.summary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 190px;\n  border-radius: 8px;\n  border: 1px solid #e1e9ef;\n}\n\n.summary-content {\n  width: 50%;\n  height: 100%;\n  padding: 20px;\n}\n\n.data {\n  display: flex;\n}\n\np.text-gray-700 {\n  margin: 0px;\n}\n\n.shipment-status-content-header {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  width: 150px;\n  height: 150px;\n  top: 340px;\n  left: 630px;\n  gap: 0px;\n  border-radius: 100px 0px 0px 0px;\n  opacity: 0px;\n}\n\n.icon-container {\n  width: 150px;\n  height: 150px;\n  border-radius: 100px;\n  background: hsl(167, 60%, 97%);\n  display: flex;\n  justify-content: center;\n  margin-top: 35px;\n  align-items: center;\n}\n\n.icon-container.error {\n  background-color: #ff00000a !important;\n}\n\n.icon-container img {\n  width: 60px;\n  height: 48px;\n}\n\n.divider {\n  width: 1px;\n  height: 100%;\n  background: #e1e9ef;\n}\n\n.col-span-2.flex.justify-between.items-center {\n  height: 74px;\n  width: 100%;\n  border: 1px solid #e1e9ef;\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 8px;\n\n}\n\n.data.downloand-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 20px;\n}\n\n.downloand-container a {\n  color: #4793ef;\n  text-decoration: none;\n}\n\n.button-shipment-status {\n  margin-right: 20px;\n}\n\n.footer-status {\n  width: 100%;\n  margin-bottom: 100px;\n}\n\n.footer-status h3 {\n  font-family: Nunito;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 42px;\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.footer-status p {\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 400;\n  color: #777a7c;\n  line-height: 22px;\n  text-align: left;\n}\n\n@media (max-width: 920px) {\n  .summary {\n    flex-direction: column;\n    height: auto;\n    align-items: start;\n  }\n  .divider {\n    width: calc(100% - 40px);\n    height: 1px;\n    background: #e1e9ef;\n    margin: 0 20px;\n  }\n}\n\n@media (max-width: 785px) {\n  .col-span-2.flex.justify-between.items-center {\n    flex-direction: column;\n    height: auto;\n    padding: 15px 0;\n    align-items: start;\n  }\n  .button-shipment-status {\n    width: calc(100% - 40px);\n    margin: 12px 20px;\n  }\n  .downloand-container a {\n    word-break: break-word;\n    /* word-wrap: break-word; */\n  }\n  .data.downloand-container{\n    margin: 0 20px;\n  }\n  .button-container {\n    width: 91.4%;\n  }\n\n  .animated-button {\n    width: 100%;\n  }\n}\n\n\n\n.animated-button {\n  animation: showHideShadow 2s infinite;\n}\n\n@keyframes showHideShadow {\n  0%, 100% {\n      box-shadow: 0 0 0 rgba(0, 0, 0, 0);\n  }\n  50% {\n      box-shadow: 0 0 20px #4793ef;\n  }\n}\n\n\n.button-container {\n  margin-right: 20px;\n  margin-left: 20px;\n}\n\n.footer-status strong {\n  font-family: Nunito;\n  font-size: 16px;\n  color: #777a7c;\n  line-height: 22px;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
